import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Paginated } from '../../core/model/paginated.model';
import { Observable } from 'rxjs';
import { Product } from '../model/product.model';

import { environment } from '@env/environment.prod';

@Injectable()
export class ProductService extends BaseAPIClass {
  public isLoading = false;
  baseUrl = environment.serverBaseUrl;
  private productosSearchUrl = this.baseUrl + '/productos/search?term=';

  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);

    this.baseUrl = this.baseUrl + '/productos';
  }

  getProductosExistencia(): Observable<Product[]> {
    return this.httpClient.get<Product[]>(this.baseUrl + '/orden');
  }

  getProductosAlmacen(): Observable<Product[]> {
    return this.httpClient.get<Product[]>(this.baseUrl + '/habilitados');
  }
  enableProduct(id: number) {
    return this.httpClient.get(this.baseUrl + '/habilitar/' + id);
  }

  getProductos(): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(this.baseUrl)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  getProductosAtUrl(url: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(url)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  getProductosAtUrl2(pagenumber: number): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(this.baseUrl + "?page="+pagenumber)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  updateProduct(id: string, object: any) {
    return this.httpClient.post(this.baseUrl + '/' + id, object);
  }

  search(term: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(`${this.productosSearchUrl}${term}`)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    // this.isLoading = false;
    return Promise.reject(error.message || error);
  }
}
